import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {UserSubscription} from '../../user/user-subscription';
import * as fromStore from "../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";

@Injectable()
export class UserSubscriptionResolver implements Resolve<UserSubscription|null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUserSubscription)),
          first()
        )
        .subscribe((userSubscription: UserSubscription) => {
          resolve(userSubscription);
        });
    });
  }
}
